import styled from 'styled-components';
import { INNER_DOC_CARD_TEMPLATE_COLUMNS } from '../../../../app/pages/Documents/style';

export const Legend = styled.div`
  display: grid;
  gap: 38px;
  grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  margin-bottom: 16px;
`;

export const DocumentCard = styled(Legend)`
  height: 100px;
  padding: 29px 0 22px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  align-items: center;

  @media ${(props) => props.theme.device.mobileL} {
    height: fit-content;
    grid-template-columns: 120px 1fr;
    gap: 8px;

    > *:nth-child(even) {
      text-align: right;
    }
  }
`;

export const FileImg = styled.img`
  width: 30px;
  height: 30px;
  display: block;
  margin-left: auto;
`;
